import { useMemo } from "react";

import type { Dayjs } from "dayjs";

import { useTranslate } from "@similarweb/i18n-provider";

import { useMinMaxDate } from "./useMinMaxDate";

const PRESET_DAYS = [1, 7, 30, 60, 90];

const createPresetId = (days: number) => `${days}d`;

export const SAME_DAY_PRESET_ID = createPresetId(1);

export interface IPreset {
    id: string;
    text: string;
    value: { from: Dayjs; to: Dayjs };
}

export const usePresets = () => {
    const { translate } = useTranslate();
    const { minDate, maxDate } = useMinMaxDate();

    return useMemo(
        () =>
            PRESET_DAYS.map<IPreset>((days) => {
                const id = createPresetId(days);
                const from = maxDate.subtract(days - 1, "day");
                const text = translate("common.datepicker.last-n-days", { count: days });

                return {
                    id,
                    text,
                    value: { from, to: maxDate },
                };
            }).filter((preset) => !preset.value.from.isBefore(minDate)),
        [translate, maxDate, minDate],
    );
};
